import React, { useState } from 'react';
import SectionEdition, { Slot } from 'components/styleguide/section_edition/SectionEdition';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import SkillsSearchInput, { Skill } from 'components/styleguide/search_input/variants/SkillsSearchInput';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

interface SkillsSectionProps {
  skills: Skill[];
  url: string;
  required?: boolean;
}

const SkillsSection: React.FC<SkillsSectionProps> = ({ skills: initialSkills, url, required = false }) => {
  const [skills, setSkills] = useState<Skill[]>(initialSkills || []);
  const [pendingSkills, setPendingSkills] = useState<Skill[]>([]);

  const sheet = useEditableSheet({
    url: url,
    payloadKey: 'talent',
    onSuccess: () => {
      setSkills(pendingSkills);
    },
  });

  const hasAny = skills.length > 0;
  const status = hasAny ? 'complete' : required ? 'mandatory' : 'missing';

  const handleAddClick = () => {
    sheet.open('Add skills', {});
  };

  const handleEditClick = () => {
    setPendingSkills(skills);
    sheet.open('Edit skills', {
      skill_ids: skills.map(s => s.value),
    });
  };

  const handleSkillsChange = (updated: Skill[]) => {
    setPendingSkills(updated);
    sheet.handleFormChange('skill_ids', updated.map(s => s.value));
  };

  return (
    <>
      <SectionEdition
        title="Skills"
        iconName="brain"
        context="talent"
        status={status}
        onEdit={handleEditClick}
        onAdd={hasAny ? undefined : handleAddClick}
      >
        {hasAny && (
          <Slot>
            <p className={styles.value}>
              {skills.map(s => s.label).join(', ')}
            </p>
          </Slot>
        )}
      </SectionEdition>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="talent"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <SkillsSearchInput
            initialSkills={skills}
            required={true}
            error={sheet.getError('skill_ids')}
            onChange={handleSkillsChange}
            context="talent"
          />
        </Sheet>
      )}
    </>
  );
};

export default SkillsSection;
